/* eslint-disable react/prop-types */
import React from 'react';
import "./style.css";

export const CenterModule = ({children}) => {
  return (
    <div className="overlay">
      <div className="centered-module">
        {children}
      </div>
    </div>
  );
};

export default CenterModule;